import styled from 'styled-components';

/**
 * The disclosure reveal from the design handoff — the one thing AntD has no
 * primitive for. Everything else on the login screen uses stock components.
 */
export const LegacyPanel = styled.div`
	animation: loginDisclosureReveal 180ms ease-out;

	@keyframes loginDisclosureReveal {
		from {
			opacity: 0;
			transform: translateY(-6px);
		}
		to {
			opacity: 1;
			transform: none;
		}
	}

	@media (prefers-reduced-motion: reduce) {
		animation: none;
	}
`;
